const parseGeolocationPayload = (input) => {
  if (!input) return null;
  let geolocation = input;
  if (typeof geolocation === 'string') {
    try {
      geolocation = JSON.parse(geolocation);
    } catch {
      return null;
    }
  }
  return geolocation;
};

const extractPoint = (point) => {
  if (!point) return null;
  if (typeof point === 'object') {
    const lat = point.lat ?? point.latitude ?? point?.[0];
    const lng = point.lng ?? point.longitude ?? point?.[1];
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return { lat, lng };
    }
  } else if (Array.isArray(point) && point.length >= 2) {
    const [lat, lng] = point;
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return { lat, lng };
    }
  }
  return null;
};

export const normalizeProjectGeolocation = (project) => {
  if (!project) return null;
  const geolocation = parseGeolocationPayload(project.geolocation);
  if (!geolocation) return null;

  // Prefer explicit lat/lng (center)
  const center =
    extractPoint(geolocation) ||
    extractPoint(geolocation.center) ||
    (Array.isArray(geolocation.trail) ? extractPoint(geolocation.trail[0]) : null) ||
    (Array.isArray(geolocation) ? extractPoint(geolocation[0]) : null);

  return center;
};

export const getProjectTrailPoints = (project) => {
  if (!project) return [];
  const geolocation = parseGeolocationPayload(project.geolocation);
  if (!geolocation) return [];

  if (Array.isArray(geolocation)) {
    return geolocation;
  }

  if (Array.isArray(geolocation.trail)) {
    return geolocation.trail;
  }

  return [];
};

export const projectHasGeolocation = (project) => {
  return Boolean(normalizeProjectGeolocation(project));
};

export const projectHasTrail = (project) => {
  return getProjectTrailPoints(project).length > 1;
};

